import { jsx as r, jsxs as n } from "react/jsx-runtime";
import p from "classnames";
import { useMemo as d } from "react";
import e from "./index.es5746.js";
import { UtilityChevronIcon as h } from "./index.es422.js";
import { Heading as u } from "./index.es489.js";
import { HelpButton as v } from "./index.es8.js";
import { BodyText as C } from "./index.es487.js";
const I = ({
  headerVariant: a,
  children: o,
  headerInfo: i,
  description: s,
  title: m
}) => {
  const t = a === "first", f = o && t, c = p(e.info, { [e.hasLeftComponent]: f }), l = d(() => {
    if (o && t)
      return o;
    if (!t)
      return /* @__PURE__ */ r(h, { direction: "left", "data-testid": "utility-chevron-icon" });
  }, [o, t]);
  return /* @__PURE__ */ n("div", { className: c, children: [
    l,
    /* @__PURE__ */ n("div", { className: e.textContainer, children: [
      /* @__PURE__ */ n("div", { className: e.headerContainer, children: [
        /* @__PURE__ */ r(u, { variant: t ? "h3" : "h4", children: m }),
        i && /* @__PURE__ */ r(v, { ...i })
      ] }),
      t && s && /* @__PURE__ */ r(C, { variant: "regular", children: s })
    ] })
  ] });
};
export {
  I as HeaderInfo
};
//# sourceMappingURL=index.es5615.js.map
